import { Button, TableCell, TableRow } from "@mui/material";
import { ProjectResponse, useGetApiProjectsByProjectIdQuery, useGetApiProjectsByProjectIdSummationQuery } from "api/generatedApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useState } from "react";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";
import { useProjects } from "../contexts/project-context";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { useTranslation } from "react-i18next";

interface ProjectRowProps {
  project: ProjectResponse;
  isHidden: boolean;
  primaryProject?: string;
  setAsPrimary: (projectId: string) => void;
}

export const ProjectTableRow = ({ project, isHidden, primaryProject, setAsPrimary }: ProjectRowProps) => {
  const { hideProjectMutation, unhideProjectMutation, refetchProjects } = useProjects();
  const { data } = useGetApiProjectsByProjectIdQuery(project.projectId ? { projectId: project.projectId } : skipToken);
  const { data: summaryData, isError: summaryError } = useGetApiProjectsByProjectIdSummationQuery({ projectId: project.projectId ?? "" });
  const [isProjectHidden, setIsProjectHidden] = useState(isHidden);
  const { screenSize } = useScreenSize();
  const { t } = useTranslation();

  const lumpsumInDkk = summaryData?.totalPaymentDkr?.toLocaleString("da-DK", {
    style: "currency",
    currency: "DKK",
  });

  const handleHideToggle = async (checked: boolean) => {
    setIsProjectHidden(checked);
    if (project.projectId) {
      if (checked) {
        await hideProjectMutation(project.projectId);
        refetchProjects();
      } else {
        await unhideProjectMutation(project.projectId);
        refetchProjects();
      }
    }
  };

  return (
    <TableRow key={project.projectId}>
      <TableCell sx={{ color: "primary.main" }}>
        <Button onClick={() => setAsPrimary(project.projectId ?? "")} sx={{ pr: 1, pl: 0, minWidth: 0, width: "auto" }}>
          {primaryProject === project.projectId ? <StarIcon /> : <StarOutlineIcon />}
        </Button>
        {project.projectName}
      </TableCell>
      {screenSize != ScreenSizeEnum.Desktop && screenSize != ScreenSizeEnum.Mobile && <TableCell sx={{ color: "primary.main" }}>{t(`account.projects.roles.${project.currentUserRole}`)}</TableCell>}
      {screenSize != ScreenSizeEnum.Desktop && screenSize != ScreenSizeEnum.Mobile && <TableCell sx={{ color: "primary.main" }}>{data?.companyName ?? ""}</TableCell>}
      <TableCell sx={{ color: "primary.main" }}>{lumpsumInDkk ?? 0}</TableCell>
      <TableCell>
        <input type="checkbox" checked={isProjectHidden} onChange={(e) => handleHideToggle(e.target.checked)} />
      </TableCell>
    </TableRow>
  );
};
